module.exports = __webpack_public_path__ + "img/stock6.a6be9e5f.png";